module.exports = __webpack_public_path__ + "img/nav-btn.3d0c6326.svg";